import { Map } from 'immutable'
import {
  SET_FILTERS_PROCESSING,
  SET_FILTERS_PLACEMENTS_DATA,
  SET_FILTERS_ERROR,
  SET_FILTERS_DATE_RANGE_DATA,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_FILTERS_PROCESSING:
      return state.setIn(['processing'], payload.processing)
    case SET_FILTERS_PLACEMENTS_DATA:
      return state
        .setIn(['placements'], payload.data)
        .setIn(['processing'], false)
    case SET_FILTERS_DATE_RANGE_DATA:
      return state
        .setIn(['dateRangeValues'], payload.data)
        .setIn(['processing'], false)
    case SET_FILTERS_ERROR:
      return state
        .setIn(['error'], payload.error)
        .setIn(['processing'], false)
    default:
      return state
  }
}
